/* codebeans homepage interactions (ported from the original site behaviour).
   The design CSS hides most elements with opacity:0 until `.codebeans-animate-in`
   is added, and defines a custom portfolio "view" cursor + animated stat counters.
   The original relied on a huge base64 bundle we did not port; this reproduces the
   three visible behaviours: scroll reveal, stat count-up, and the follow cursor.
   Carousel cards (.codebeans-testimonial-card / .codebeans-service-card) are left
   alone — they show one at a time via their own `.active` class + section JS. */
(function () {
  if (window.__mwInit) return;
  window.__mwInit = true;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var CARD_SKIP = 'codebeans-testimonial-card codebeans-service-card'.split(' ');

  function isCard(el) {
    for (var i = 0; i < CARD_SKIP.length; i++) if (el.classList.contains(CARD_SKIP[i])) return true;
    return false;
  }

  function revealTree(root) {
    if (!isCard(root)) root.classList.add('codebeans-animate-in');
    var kids = root.querySelectorAll('[class*="codebeans-"]');
    for (var i = 0; i < kids.length; i++) {
      if (!isCard(kids[i])) kids[i].classList.add('codebeans-animate-in');
    }
  }

  /* ---- Stat count-up ---- */
  function animateCounter(el) {
    if (el.__counted) return;
    el.__counted = true;
    var finalText = el.textContent.trim();
    var target = parseFloat((el.getAttribute('data-target') || finalText).replace(/[^\d.]/g, ''));
    if (!isFinite(target) || target <= 0) return;
    var leading = finalText.match(/^[\d.,]+/);
    var trailing = leading ? finalText.slice(leading[0].length) : '';
    var hasDecimal = /\./.test(leading ? leading[0] : '');
    if (reduceMotion) { el.textContent = finalText; return; }
    var start = null, duration = 1800;
    function frame(ts) {
      if (start === null) start = ts;
      var p = Math.min((ts - start) / duration, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      var val = target * eased;
      var shown = hasDecimal ? (Math.round(val * 10) / 10).toFixed(1) : Math.round(val).toString();
      el.textContent = shown + trailing;
      if (p < 1) requestAnimationFrame(frame);
      else el.textContent = finalText;
    }
    requestAnimationFrame(frame);
  }

  function runStatCounters(section) {
    var nums = section.querySelectorAll('.codebeans-stat-number[data-target], .codebeans-stat-value[data-target]');
    for (var i = 0; i < nums.length; i++) {
      (function (n, idx) { setTimeout(function () { animateCounter(n); }, idx * 120); })(nums[i], i);
    }
  }

  /* ---- Scroll reveal ---- */
  function initReveal() {
    var sections = document.querySelectorAll('.mw-home [class*="codebeans-"][id], .mw-home > .codebeans-hero, .mw-home > .codebeans-about, .mw-home > .codebeans-partners, .mw-home > .codebeans-stats, .mw-home > .codebeans-video-testimonial, .mw-home > .codebeans-portfolio-showcase, .mw-home > .codebeans-cta-section, .mw-home > .codebeans-branding-strategy, .mw-home > .codebeans-testimonials, .mw-home > .codebeans-final-cta, .mw-home > .codebeans-faq, .mw-home > .codebeans-about-stats, .mw-home > .codebeans-about-quote, .mw-home > .codebeans-about-team, .mw-home > .codebeans-about-process');
    var targets = sections.length ? sections : document.querySelectorAll('.mw-home > *');

    if (!('IntersectionObserver' in window) || reduceMotion) {
      for (var i = 0; i < targets.length; i++) { revealTree(targets[i]); if (targets[i].querySelector) runStatCounters(targets[i]); }
      return;
    }

    var obs = new IntersectionObserver(function (entries, observer) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        revealTree(entry.target);
        runStatCounters(entry.target);
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

    for (var j = 0; j < targets.length; j++) obs.observe(targets[j]);

    // Safety net (in case the observer never fires on this page/browser):
    // reveal every target currently within the viewport. Runs now, on load, and
    // on scroll — so above-the-fold content shows immediately and below-the-fold
    // content still reveals as it scrolls in, even if the observer is silent.
    var remaining = targets.length;
    function revealInView() {
      if (!remaining) return;
      var vh = window.innerHeight || document.documentElement.clientHeight;
      for (var k = 0; k < targets.length; k++) {
        var t = targets[k];
        if (t.classList.contains('codebeans-animate-in')) continue;
        var r = t.getBoundingClientRect();
        if (r.top < vh - 40 && r.bottom > 0) {
          revealTree(t); runStatCounters(t); obs.unobserve(t); remaining--;
        }
      }
    }
    window.addEventListener('load', revealInView);
    window.addEventListener('scroll', revealInView, { passive: true });
    revealInView();
  }

  /* ---- Follow "view" cursor over portfolio / project cards ---- */
  /* Follow cursor that only activates while over a specific child (e.g. a
     portfolio card) — not the whole zone's empty gaps. */
  function bindCardCursor(zone, btn, cardSel) {
    if (!zone || !btn) return;
    function onCard(e) { return e.target && e.target.closest ? e.target.closest(cardSel) : null; }
    zone.addEventListener('mousemove', function (e) {
      if (onCard(e)) {
        btn.classList.add('codebeans-cursor-active');
        btn.style.setProperty('left', e.clientX + 'px', 'important');
        btn.style.setProperty('top', e.clientY + 'px', 'important');
      } else {
        btn.classList.remove('codebeans-cursor-active');
      }
    });
    zone.addEventListener('mouseleave', function () { btn.classList.remove('codebeans-cursor-active'); });
    zone.addEventListener('mousedown', function (e) { if (onCard(e)) btn.classList.add('codebeans-click-effect'); });
    zone.addEventListener('mouseup', function () { btn.classList.remove('codebeans-click-effect'); });
  }

  function initCursor() {
    // Portfolio showcase grid — only show the "view" cursor over actual cards
    bindCardCursor(
      document.querySelector('.mw-home .codebeans-portfolio-grid'),
      document.getElementById('portfolioFloatingBtn'),
      '.codebeans-portfolio-card'
    );
    // Auto-scrolling project gallery (home hero, About): "view" follower only
    // while the pointer is over a project card, like the portfolio grid.
    var galleries = document.querySelectorAll('.mw-home .codebeans-portfolio-gallery');
    for (var i = 0; i < galleries.length; i++) {
      var viewBtn = galleries[i].querySelector('.codebeans-view-button');
      // The gallery's wrappers form a containing block, so a position:fixed
      // child is offset from the pointer; the follower lives on <body> instead.
      if (viewBtn) document.body.appendChild(viewBtn);
      bindCardCursor(galleries[i], viewBtn, '.codebeans-portfolio-item');
    }
  }

  /* ---- Portfolio search filter ---- */
  function initSearch() {
    var forms = document.querySelectorAll('.mw-home [data-project-search]');
    for (var f = 0; f < forms.length; f++) {
      (function (form) {
        var input = form.querySelector('.codebeans-project-search-input');
        var grid = document.querySelector('.mw-home .codebeans-portfolio-grid');
        if (!input || !grid) return;
        var cards = grid.querySelectorAll('.codebeans-portfolio-card');
        var empty = grid.querySelector('.codebeans-portfolio-no-results');
        function apply() {
          var q = (input.value || '').toLowerCase().trim();
          var shown = 0;
          for (var i = 0; i < cards.length; i++) {
            var hay = cards[i].getAttribute('data-search') || '';
            var match = q === '' || hay.indexOf(q) !== -1;
            cards[i].style.display = match ? '' : 'none';
            if (match) shown++;
          }
          if (empty) empty.hidden = shown !== 0;
        }
        input.addEventListener('input', apply);
        form.addEventListener('submit', function (e) { e.preventDefault(); apply(); });
      })(forms[f]);
    }
  }

  /* ---- Scroll-driven slide (portfolio + partners) & rotation (floating shapes) ---- */
  function initScrollFX() {
    if (reduceMotion) return;

    // Floating shapes that rotate with scroll (selector, factor, direction, needs translateY(-50%))
    var ROT = [
      { sel: '.codebeans-floating-bg-1', f: 0.15, d: 1, y: false },
      { sel: '.codebeans-floating-bg-2', f: 0.12, d: -1, y: true },
      { sel: '.codebeans-floating-bg-3', f: 0.10, d: 1, y: true },
      { sel: '.codebeans-branding-float-element', f: 0.18, d: 1, y: false },
      { sel: '.codebeans-faq-decoration-left', f: 0.18, d: 1, y: false },
      { sel: '.codebeans-faq-decoration-right', f: 0.14, d: -1, y: false },
      { sel: '.codebeans-about-floating-1', f: 0.15, d: 1, y: false },
      { sel: '.codebeans-about-floating-2', f: 0.12, d: -1, y: false },
      { sel: '.codebeans-process-floating-1', f: 0.10, d: 1, y: false },
      { sel: '.codebeans-process-floating-2', f: 0.14, d: -1, y: false }
    ];
    var rotEls = [];
    ROT.forEach(function (c) {
      var found = document.querySelectorAll('.mw-home ' + c.sel);
      for (var i = 0; i < found.length; i++) rotEls.push({ el: found[i], f: c.f, d: c.d, y: c.y });
    });

    // Portfolio gallery + partners strip autoplay on a timer (not page scroll).
    // Each slider keeps a pixel offset that advances every frame; prev/next and
    // the partner dots ease it to a target instead of jumping. Hover pauses.
    // Liquid prints the slides twice; `count` is one set, and the loop wraps
    // after exactly one set so the second copy takes its place seamlessly.
    var sliders = [];
    function addSlider(track, hoverZone, speed, prefix) {
      var s = {
        track: track,
        zone: hoverZone || track.parentNode,
        count: Math.floor(track.children.length / 2),
        speed: speed,
        prefix: prefix,
        width: 0,
        offset: 0,
        target: null,
        paused: false,
        onMove: null
      };
      track.style.animation = 'none';
      if (hoverZone) {
        // Mouse only: a tap on touch screens would otherwise leave it paused
        hoverZone.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') s.paused = true; });
        hoverZone.addEventListener('pointerleave', function () { s.paused = false; });
      }
      sliders.push(s);
      return s;
    }
    function moveTo(s, delta) {
      s.target = (s.target === null ? s.offset : s.target) + delta;
    }

    // About portfolio gallery track(s); --portfolio-scroll-factor 0.8 ≈ 48px/s
    var gtracks = document.querySelectorAll('.mw-home .codebeans-portfolio-track');
    for (var g = 0; g < gtracks.length; g++) {
      var factor = parseFloat(getComputedStyle(gtracks[g]).getPropertyValue('--portfolio-scroll-factor')) || 0.8;
      var gs = addSlider(gtracks[g], gtracks[g].closest('.codebeans-portfolio-gallery-wrapper'), factor * 60, 'translateY(-50%) ');
      (function (gs) {
        var wrap = gs.track.closest('.codebeans-portfolio-gallery-wrapper') || gs.track.parentNode;
        var prev = wrap.querySelector('.codebeans-gallery-nav-left');
        var next = wrap.querySelector('.codebeans-gallery-nav-right');
        function step() {
          var firstItem = gs.track.querySelector('.codebeans-portfolio-item');
          var gap = parseFloat(getComputedStyle(gs.track).columnGap) || 30;
          return firstItem ? firstItem.offsetWidth + gap : 355;
        }
        if (prev) prev.addEventListener('click', function () { moveTo(gs, -step()); });
        if (next) next.addEventListener('click', function () { moveTo(gs, step()); });
      })(gs);
    }

    // Partners logo strip, with one bullet per logo in .codebeans-partners-dots
    var partners = document.querySelector('.mw-home .codebeans-partners-track');
    var ps = null, dots = [], dotPos = [], activeDot = -1;
    if (partners) {
      ps = addSlider(partners, partners.closest('.codebeans-partners'), 40, '');
      var dotWrap = partners.parentNode.querySelector('.codebeans-partners-dots');
      var logoCount = Math.floor(partners.children.length / 2);
      if (dotWrap && logoCount > 1) {
        for (var d = 0; d < logoCount; d++) {
          (function (idx) {
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'codebeans-partners-dot';
            b.setAttribute('aria-label', 'Go to logo ' + (idx + 1));
            b.addEventListener('click', function () {
              var cur = (ps.target === null ? ps.offset : ps.target) % ps.width;
              if (cur < 0) cur += ps.width;
              moveTo(ps, dotPos[idx] - cur);
            });
            dotWrap.appendChild(b);
            dots.push(b);
          })(d);
        }
        ps.onMove = function (x) {
          var idx = 0;
          for (var i = 0; i < dotPos.length; i++) if (dotPos[i] <= x + 1) idx = i;
          if (idx === activeDot) return;
          if (activeDot > -1) dots[activeDot].classList.remove('is-active');
          dots[idx].classList.add('is-active');
          activeDot = idx;
        };
      }
    }

    // A wide screen can show more than two sets of a short strip (a few logos),
    // which would leave an empty gap before the wrap; add hidden copies of
    // the first set until the strip covers one set plus the visible width.
    function fill(s) {
      var kids = s.track.children;
      var guard = 0;
      while (s.width > 0 && s.track.scrollWidth < s.width + s.track.parentNode.clientWidth && guard++ < 10) {
        for (var i = 0; i < s.count; i++) {
          var clone = kids[i].cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          clone.removeAttribute('data-shopify-editor-block');
          var focusables = clone.querySelectorAll('a, button');
          for (var f = 0; f < focusables.length; f++) focusables[f].setAttribute('tabindex', '-1');
          var imgs = clone.querySelectorAll('img');
          for (var m = 0; m < imgs.length; m++) imgs[m].alt = '';
          s.track.appendChild(clone);
        }
      }
    }

    function recompute() {
      for (var i = 0; i < sliders.length; i++) {
        var s = sliders[i], kids = s.track.children;
        // One period = start of the second set minus start of the first, so the
        // gap between the sets is included (scrollWidth / 2 is half a gap short).
        s.width = s.count > 0 && kids[s.count] ? kids[s.count].offsetLeft - kids[0].offsetLeft : 0;
        fill(s);
      }
      if (partners && dots.length) {
        var first = partners.children[0].offsetLeft;
        for (var j = 0; j < dots.length; j++) dotPos[j] = partners.children[j].offsetLeft - first;
      }
    }

    // The frame loop only runs while a slider is on screen; offscreen strips
    // hold their position and carry on from there when they scroll back in.
    var last = 0;
    var running = false;
    var canObserve = 'IntersectionObserver' in window;
    for (var v = 0; v < sliders.length; v++) sliders[v].visible = !canObserve;
    function anyVisible() {
      for (var i = 0; i < sliders.length; i++) if (sliders[i].visible) return true;
      return false;
    }
    function start() {
      if (running || !anyVisible()) return;
      running = true;
      last = 0;
      requestAnimationFrame(frame);
    }
    function frame(now) {
      if (!anyVisible()) { running = false; return; }
      var dt = last ? Math.min((now - last) / 1000, 0.1) : 0;
      last = now;
      for (var i = 0; i < sliders.length; i++) {
        var s = sliders[i];
        if (s.width <= 0 || !s.visible) continue;
        if (s.target !== null) {
          var diff = s.target - s.offset;
          if (Math.abs(diff) < 0.5) { s.offset = s.target; s.target = null; }
          else s.offset += diff * 0.12;
        } else if (!s.paused) {
          s.offset += s.speed * dt;
        }
        var x = s.offset % s.width; if (x < 0) x += s.width;
        s.track.style.transform = s.prefix + 'translateX(-' + x + 'px)';
        if (s.onMove) s.onMove(x);
      }
      requestAnimationFrame(frame);
    }
    recompute();
    // Lazy-loaded logos/covers change the track width after first paint
    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(recompute);
      for (var t = 0; t < sliders.length; t++) {
        var kids = sliders[t].track.children;
        for (var c = 0; c < kids.length; c++) ro.observe(kids[c]);
      }
    }
    // Watch the slider's frame, not the moving track: the track's own box is
    // only as wide as its container, so once it slid one container-width the
    // observer reported it offscreen and the loop stopped for good.
    if (canObserve) {
      var io = new IntersectionObserver(function (entries) {
        for (var e = 0; e < entries.length; e++) {
          for (var k = 0; k < sliders.length; k++) {
            if (sliders[k].zone === entries[e].target) sliders[k].visible = entries[e].isIntersecting;
          }
        }
        start();
      }, { rootMargin: '100px 0px' });
      for (var o = 0; o < sliders.length; o++) io.observe(sliders[o].zone);
    } else {
      start();
    }

    // Floating shapes still rotate with page scroll
    function update() {
      var y = window.pageYOffset || document.documentElement.scrollTop || 0;
      for (var r = 0; r < rotEls.length; r++) {
        var it = rotEls[r];
        var deg = y * it.f * it.d;
        if (it.y) it.el.style.transform = 'translateY(-50%) rotate(' + deg + 'deg)';
        else it.el.style.transform = 'rotate(' + deg + 'deg)';
      }
    }

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { update(); ticking = false; });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () { recompute(); update(); });
    window.addEventListener('load', function () { recompute(); update(); });

    requestAnimationFrame(update);
  }

  /* ---- Magnetic hero CTA (writes --dx/--dy, cursor-follow) ---- */
  function initMagneticButton() {
    var cta = document.getElementById('codebeansHeroCta');
    var hero = document.querySelector('.mw-home .codebeans-hero');
    if (!cta || !hero || reduceMotion) return;

    var RADIUS = 240;     // engage distance from the button centre (px)
    var MAX_PULL = 42;    // max drift of the button (px)
    var PULL = 0.35;      // how strongly the button chases the cursor
    var EASE = 0.15;      // lerp factor toward the target
    var tx = 0, ty = 0, cx = 0, cy = 0, raf = null, active = false;

    function clamp(v) { return Math.max(-MAX_PULL, Math.min(MAX_PULL, v)); }

    function loop() {
      cx += (tx - cx) * EASE;
      cy += (ty - cy) * EASE;
      cta.style.setProperty('--dx', cx.toFixed(2) + 'px');
      cta.style.setProperty('--dy', cy.toFixed(2) + 'px');
      if (Math.abs(tx - cx) > 0.1 || Math.abs(ty - cy) > 0.1) {
        raf = requestAnimationFrame(loop);
      } else {
        cx = tx; cy = ty;
        cta.style.setProperty('--dx', cx.toFixed(2) + 'px');
        cta.style.setProperty('--dy', cy.toFixed(2) + 'px');
        raf = null;
      }
    }
    function kick() { if (!raf) raf = requestAnimationFrame(loop); }

    hero.addEventListener('mousemove', function (e) {
      var r = cta.getBoundingClientRect();
      var dx = e.clientX - (r.left + r.width / 2);
      var dy = e.clientY - (r.top + r.height / 2);
      if (Math.sqrt(dx * dx + dy * dy) < RADIUS) {
        if (!active) { active = true; cta.classList.add('is-following'); }
        tx = clamp(dx * PULL);
        ty = clamp(dy * PULL);
      } else if (active) {
        active = false; cta.classList.remove('is-following'); tx = 0; ty = 0;
      }
      kick();
    });
    hero.addEventListener('mouseleave', function () {
      active = false; cta.classList.remove('is-following'); tx = 0; ty = 0; kick();
    });
  }

  /* ---- Multilingual "Hello" typewriter (about eyebrow) ---- */
  // function initHelloTyping() {
  //   var el = document.querySelector('.mw-home #codebeansMultilingualHello') ||
  //            document.querySelector('.mw-home .codebeans-hello-text');
  //   if (!el) return;
  //   // Greetings: Hello, Merhaba, Hola, Bonjour, Ciao, Hallo, Ola, Privet, NiHao, Konnichiwa, Marhaba
  //   var greetings = ['Hello', 'Merhaba', 'Hola', 'Bonjour', 'Ciao', 'Hallo', 'Olá',
  //     'Привет', '你好', 'こんにちは', 'مرحبا'];
  //   if (reduceMotion) { el.textContent = greetings[0]; return; }
  //   var idx = 0;
  //   function typeNext() {
  //     var word = greetings[idx];
  //     el.textContent = '';
  //     el.className = 'codebeans-hello-text codebeans-multilingual-typing';
  //     var ci = 0;
  //     (function typeChar() {
  //       if (ci < word.length) {
  //         el.textContent += word.charAt(ci++);
  //         setTimeout(typeChar, 100);
  //       } else {
  //         setTimeout(function () {
  //           el.classList.add('codebeans-erasing');
  //           (function eraseChar() {
  //             if (el.textContent.length > 0) {
  //               el.textContent = el.textContent.slice(0, -1);
  //               setTimeout(eraseChar, 50);
  //             } else {
  //               el.classList.remove('codebeans-erasing');
  //               el.textContent = ' ';
  //               idx = (idx + 1) % greetings.length;
  //               setTimeout(typeNext, 500);
  //             }
  //           })();
  //         }, 1500);
  //       }
  //     })();
  //   }
  //   setTimeout(typeNext, 300);
  // }
function initHelloTyping() {

  var el = document.querySelector('.mw-home #cbDynamicTypingText');

  if (!el) return;

  var textString = el.getAttribute('data-typing-text');

  if (!textString) return;

  var texts = textString
    .split('-')
    .map(function(text) {
      return text.trim();
    })
    .filter(function(text) {
      return text !== '';
    });

  if (!texts.length) return;

  if (reduceMotion) {
    el.textContent = texts[0];
    return;
  }

  var idx = 0;

  function typeNext() {

    var word = texts[idx];

    el.textContent = '';
    el.className = 'codebeans-hello-text codebeans-dynamic-typing';

    var ci = 0;

    (function typeChar() {

      if (ci < word.length) {

        el.textContent += word.charAt(ci++);

        setTimeout(typeChar, 150);

      } else {

        setTimeout(function () {

          el.classList.add('codebeans-erasing');

          (function eraseChar() {

            if (el.textContent.length > 0) {

              el.textContent =
                el.textContent.slice(0, -1);

              setTimeout(eraseChar, 100);

            } else {

              el.classList.remove('codebeans-erasing');

              el.textContent = ' ';

              idx = (idx + 1) % texts.length;

              setTimeout(typeNext, 700);
            }

          })();

        }, 2500);
      }

    })();
  }

  setTimeout(typeNext, 300);
}
  function run() {
    // Each init is isolated so one throwing (e.g. on a page missing some elements)
    // never prevents the others — notably initScrollFX (floating-shape rotation).
    var inits = [initReveal, initCursor, initSearch, initScrollFX, initHelloTyping, initMagneticButton];
    for (var i = 0; i < inits.length; i++) {
      try { inits[i](); } catch (e) { if (window.console) console.warn('mw init failed:', e); }
    }
  }
  if (document.readyState !== 'loading') run();
  else document.addEventListener('DOMContentLoaded', run);






  
  
})();

